module.exports = __webpack_public_path__ + "static/media/3 11 Tulleord Peano er feil-norming.259cc53f.mp3";